<template>
    <div>
        <order-report-grid-view-modal v-if="isSponsor">
            <template v-slot:modal-link>
                View as
            </template>
        </order-report-grid-view-modal>

        <order-report-grid-modal v-if="selectedReportId === null" :report-id="selectedReportId"
            v-on:report-updated="reportUpdated" :is-new="true">
            <template v-slot:modal-link>
                Save as
            </template>
        </order-report-grid-modal>
        
        <base-button v-if="selectedReportId !== null" type="danger" @click.native="handleClear()" class="mr-4">
            <i class="tim-icons icon-simple-remove"></i> Cancel
        </base-button>
        
        <base-button :loading="loading" v-if="selectedReportId !== null" class="btn-primary"
            @click.native="handleUpdate()">
            <i class="tim-icons icon-check-2"></i> Update
        </base-button>
        
        <div class="row">
            <div class="col-sm-12">
                <el-table :data="reports" role="table" aria-label="Order Report Table">
                    <el-table-column :min-width="160" align="left" label="Actions">
                        <div slot-scope="props" class="table-actions">
                            <el-tooltip class="mr-4" content="Delete" :open-delay="300" effect="light" placement="top">
                                <order-report-grid-delete :isIcon="true"
                                    :disabled="selectedReportId !== null && selectedReportId !== props.row.id"
                                    :id="props.row.id">
                                    <template v-slot:modal-link>
                                        <i class="tim-icons icon-trash-simple"></i> Delete
                                    </template>
                                </order-report-grid-delete>
                            </el-tooltip>
                            <el-tooltip class="mr-4" content="Edit" :open-delay="300" effect="light" placement="top">
                                <order-report-grid-modal :is-new="false"
                                    :disabled="selectedReportId !== null && selectedReportId !== props.row.id"
                                    :report-id="props.row.id" :is-icon="true">
                                    <template v-slot:modal-link>
                                        <i class="tim-icons icon-pencil"></i> Rename
                                    </template>
                                </order-report-grid-modal>
                            </el-tooltip>
                            <el-tooltip content="Load" :open-delay="300" effect="light" placement="top">
                                <base-button :loading="loading" :disabled="selectedReportId !== null"
                                    :class="'btn-primary'" @click.native="handleLoadReport(props.row.id)">
                                    <i class="tim-icons icon-app"></i> Load
                                </base-button>
                            </el-tooltip>
                        </div>
                    </el-table-column>

                    <el-table-column v-for="column in tableColumns" sortable :key="column.label"
                        :min-width="column.minWidth" :formatter="column.formatter" :prop="column.prop"
                        :label="column.label">
                    </el-table-column>

                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Table, TableColumn } from 'element-ui'
import { BaseSwitch, BaseButton, Modal } from '@/components'
import OrderReportGridModal from "@/components/App/report/order/OrderReportGridModal.vue";
import OrderReportGridViewModal from "@/components/App/report/order/OrderReportGridViewModal.vue";
import OrderReportGridDelete from "@/components/App/report/order/OrderReportGridDelete.vue";

export default {
    name: "order-report-grid-any",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BaseSwitch,
        BaseButton,
        Modal,
        OrderReportGridModal,
        OrderReportGridViewModal,
        OrderReportGridDelete,
    },

    data() {
        return {
            tableColumns: [{
                prop: 'name',
                label: 'Name',
                minWidth: 150,
                scope: "col"
            },
            {
                prop: 'type',
                label: 'Type',
                minWidth: 100,
                scope: "col"
            }],
            selectedReportId: null,
            loading: false,
            isNewReport: true,
        }
    },
    mounted() {
        this.getReports();
    },
    computed: {
        ...mapGetters({
            reports: "orderReport/reports",
            isSponsor: "authentication/isSponsor",
        })
    },
    methods: {
        ...mapActions({
            getReports: "orderReport/getReports",
            getReport: "orderReport/getReport",
            saveReport: "orderReport/saveReport",
            clear: "orderReport/clearReport",
        }),
        handleClear() {
            this.selectedReportId = null;
            this.isNewReport = true;
            this.clear();
        },
        handleLoadReport(reportId) {
            this.selectedReportId = reportId;
            this.isNewReport = false;
            this.loading = true;
            this.getReport(reportId);
            this.loading = false;
        },
        handleUpdate() {
            this.loading = true;
            this.saveReport(this.selectedReportId);
            this.loading = false;
            this.isNewReport = true;
            this.selectedReportId = null;
        },
        reportUpdated() {
            this.loading = false;
            this.selectedReportId = null;
            this.isNewReport = true;
            this.clear();
        }
    }
}
</script>
